import { Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { LanguageContext } from '../../../../../../../libs/Context';

const CountDownTimer = () =>
{
	const { language } = useContext(LanguageContext);
	const time = { days: 0, hours: 0, minutes: 0, seconds: 0 };

	return (
		<Stack direction={'row'} mt={1} border={'1px solid rgba(49, 49, 49, 1)'} borderRadius={'6px'} spacing={4} padding={'4px 12px'}>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.days}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.days}</Typography>
			</Stack>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.hours}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.hours}</Typography>
			</Stack>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.minutes}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.sminutes}</Typography>
			</Stack>
			<Stack direction={'column'} alignItems={'center'}>
				<Typography variant='h6'>{time.seconds}</Typography>
				<Typography fontSize={'var(--pixel12)'}>{language.secondsFull}</Typography>
			</Stack>
		</Stack>
	);
};

export default CountDownTimer;